export default __webpack_public_path__ + "static/media/Augury Kick.3be0f21a.png";